import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StorageKeys } from '../util/storage-keys';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem(StorageKeys.AUTH_TOKEN);

    if (token && this.isUrlPermitida(request.url)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    return next.handle(request);
  }

  private isUrlPermitida(url: string) {
    return (
      url.indexOf('/oauth/token') === -1 &&
      url.indexOf('/calculadora-api') === -1 &&
      !url.startsWith(environment.apiUrlCalculadoraFiscal) &&
      url.indexOf('/registros') === -1 &&
      url.indexOf('www.receitaws.com.br') === -1 &&
      url.indexOf('viacep.com.br') === -1
    );
  }
}
